import {StyleSheet} from 'react-native';
import {Colors} from '../../constants/Colors';

export const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
    backgroundColor: 'white',
    paddingHorizontal: 20,
    paddingVertical: 15,
  },
  containerHeader: {
    marginTop: 40,
  },
  title: {
    textAlign: 'center',
    fontSize: 12,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 18,
    maxWidth: 280,
    alignSelf: 'center',
    color: Colors.GrayPallete.lightgrayThree,
  },
  coca: {
    alignSelf: 'flex-start',
    marginTop: 20,
  },
  containerFilter: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 20,
  },
  description: {
    fontSize: 16,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 19,
    color: 'black',
  },
  filterButton: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  filter: {
    marginRight: 10,
    fontSize: 12,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 14,
    color: Colors.RedPallete.red,
  },
  fanta: {
    alignSelf: 'center',
    marginTop: 40,
  },
  subtitle: {
    fontSize: 16,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 19,
    color: 'black',
    marginTop: 10,
  },
  containerDate: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 3,
  },
  subs: {
    fontSize: 12,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 14,
    color: Colors.GrayPallete.lightgrayThree,
  },
  date: {
    fontSize: 12,
    fontWeight: '600',
    lineHeight: 14,
    color: Colors.GrayPallete.lightgrayThree,
    fontFamily: 'TCCC-UnityText Bold',
  },
  containerButton: {
    marginTop: 30,
    width: '100%',
    alignItems: 'center',
  },
  anyQuest: {
    fontSize: 16,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 19,
    color: 'black',
    alignSelf: 'center',
    marginTop: 90,
  },
  contact: {
    fontSize: 12,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 20,
    color: Colors.GrayPallete.lightgrayThree,
    textAlign: 'center',
    maxWidth: 280,
    alignSelf: 'center',
    marginTop: 10,
  },
  phone: {
    marginTop: 50,
    alignSelf: 'center',
    fontSize: 22,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 26,
    color: Colors.GrayPallete.lightgrayThree,
  },
  service: {
    fontSize: 12,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 14,
    alignSelf: 'center',
    marginBottom: 100,
    marginTop: 10,
    color: Colors.GrayPallete.lightgrayThree,
  },
  campaignText: {
    fontSize: 16,
    lineHeight: 19,
    color: 'black',
    fontFamily: 'TCCC-UnityHeadline Regular',
    textAlign: 'center',
    maxWidth: 250,
    alignSelf: 'center',
    marginTop: 10,
  },
  spaceX: {
    paddingHorizontal: 20,
  },
  bigDesc: {
    fontSize: 12,
    lineHeight: 22,
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: Colors.GrayPallete.lightgrayThree,
    marginTop: 30,
  },
  campCa: {
    fontSize: 16,
    lineHeight: 19,
    color: 'black',
    fontFamily: 'TCCC-UnityText Bold',
    marginTop: 50,
  },
  textKit: {
    fontSize: 12,
    lineHeight: 20,
    fontFamily: 'TCCC-UnityText Bold',
    color: 'black',
    marginTop: 20,
  },
  kitDesc: {
    fontSize: 14,
    lineHeight: 20,
    color: Colors.GrayPallete.lightgrayThree,
    fontFamily: 'TCCC-UnityHeadline Regular',
    marginTop: 10,
  },
  period: {
    fontSize: 12,
    lineHeight: 20,
    fontFamily: 'TCCC-UnityText Bold',
    color: 'black',
    marginTop: 20,
  },
  dateCam: {
    fontSize: 12,
    lineHeight: 20,
    color: Colors.GrayPallete.lightgrayThree,
    marginTop: 5,
  },
  containerTermButton: {
    marginTop: 50,
    height: 100,
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});
